import * as v from 'valibot'

import { type AppEnvInput, appEnvInputSchema, resolveAppEnv } from '../../../env/shared'

const getAppEnv = () => resolveAppEnv(process.env.APP_ENV ?? process.env.NEXT_PUBLIC_APP_ENV)

export const isAppEnv = (env: AppEnvInput | AppEnvInput[]) => {
  const appEnv = getAppEnv()
  const normalizedEnv = Array.isArray(env)
    ? env.map(value => resolveAppEnv(v.parse(appEnvInputSchema, value)))
    : resolveAppEnv(v.parse(appEnvInputSchema, env))

  if (Array.isArray(normalizedEnv)) {
    return normalizedEnv.includes(appEnv)
  }
  return appEnv === normalizedEnv
}
